import { FC } from 'react';

import styles from './Toolbar.module.css';

type Props = {
  onClose: () => void;
};

const Toolbar: FC<Props> = ({ onClose }) => (
  <div className={styles.root}>
    <button onClick={onClose}>x</button>
  </div>
);

export default Toolbar;
